<form [formGroup]="form | bgoAsFormGroup" *transloco="let t">
  <div class="space-y-md">
    <label class="mt-xs font-bold">{{ t('createJobRequest.hedgeTrimming.hedgeLength.label') }}</label>
    <cft-number-input
      [formControl]="form.controls.hedgeLength | bgoAsFormControl"
      [min]="1"
      [max]="30"
      [step]="1"
      class="mt-xs block"
    />
    @if (form.controls.hedgeLength.invalid && form.controls.hedgeLength.touched) {
      <div class="mb-md error">{{ t('createJobRequest.hedgeTrimming.hedgeLength.error') }}</div>
    }
  </div>
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.hedgeLength.invalid">
    <label class="mt-xs font-bold">{{ t('createJobRequest.hedgeTrimming.hedgeHeight.label') }}</label>
    <cft-radio
      [name]="'hedgeHeight'"
      [hasWarning]="form.controls.hedgeHeight.invalid && form.controls.hedgeHeight.touched"
      [value]="2"
      formControlName="hedgeHeight"
      >{{ t('createJobRequest.hedgeTrimming.hedgeHeight.option1') }}</cft-radio
    >
    <cft-radio
      [name]="'hedgeHeight'"
      [hasWarning]="form.controls.hedgeHeight.invalid && form.controls.hedgeHeight.touched"
      [value]="3"
      formControlName="hedgeHeight"
      >{{ t('createJobRequest.hedgeTrimming.hedgeHeight.option2') }}</cft-radio
    >
  </div>
</form>
